export const header = {
    logo: {
        brandName: 'Fronteira Sul Drones',
        tagline: 'Soluções em Drones',
        ariaLabel: 'Ir para o topo da página',
    },
    navigation: {
        home: 'Início',
        drones: 'Drones',
        newDrones: 'Drones Novos',
        usedDrones: 'Drones Usados',
        buffalo: 'Linha Buffalo',
        powerCitros: 'Power Citros',
        parts: 'Peças',
        services: 'Serviços',
        about: 'Sobre',
        contact: 'Contato',
    },
    mobileMenu: {
        toggleAriaLabel: 'Alternar menu',
        closeAriaLabel: 'Fechar menu',
    },
    actions: {
        search: 'Buscar',
        cart: 'Carrinho',
        account: 'Conta',
        toggleTheme: 'Alternar tema',
        back: 'Voltar',
    },
    catalog: {
        title: 'Catálogo',
    },
};
//# sourceMappingURL=header.js.map